import React from 'react';
import { Link } from 'react-router-dom'

// import styles from './Menu.css';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import withWidth from '@material-ui/core/withWidth';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import bcicLogo from '../../assests/images/logo.png';

const styles = () => ({
    responsiveIimg: {
        position: "relative",
        left: "20px",
        height: "auto !important",
    }
})

const Menu = (props) => {

    const { classes } = props;

    return (
        <Grid
            container
        >
            <Hidden smDown>
                <Grid
                    item
                    xs={4}
                >
                    <Link to="/">
                        <img className={classes.responsiveIimg} src={bcicLogo} alt="BCIC Logo" />
                    </Link>
                </Grid>
            </Hidden>
            <Hidden mdUp>
                <Grid
                    item
                    xs={11}
                >
                    <Typography variant="headline">
                        Make A Claim
                </Typography>
                </Grid>
            </Hidden>

        </Grid>
    );
};

export default withStyles(styles)(withWidth()(Menu));



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js